import { render, staticRenderFns } from "./enrollment-list.vue?vue&type=template&id=1c5f167d&scoped=true&"
import script from "./enrollment-list.ts?vue&type=script&lang=ts&"
export * from "./enrollment-list.ts?vue&type=script&lang=ts&"
import style0 from "./enrollment-list.scss?vue&type=style&index=0&id=1c5f167d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f167d",
  null
  
)

export default component.exports